import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export default WrappedComponent => props => (
  <DndProvider backend={HTML5Backend}>
    <WrappedComponent {...props} />
  </DndProvider>
);
